import React from "react";
import { InfoText, Numbers } from "@weezevent/nacre";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import classes from "./info-number.module.scss";
import { Loader } from "semantic-ui-react";

export const InfoNumber = ({ text, value, isLoading = true }) => {
	const { i18n } = useTranslation();

	return (
		<InfoText subtitle={text} className={classes.root}>
			{isLoading ? (
				<Loader active size="mini" inline />
			) : (
				<Numbers
					className={classes.number}
					value={value}
					locale={i18n.language}
				/>
			)}
		</InfoText>
	);
};

InfoNumber.propTypes = {
	text: PropTypes.node.isRequired,
	value: PropTypes.number.isRequired,
	isLoading: PropTypes.bool
};

InfoNumber.defaultProps = {
	isLoading: false
};
